// Staff support mode (backend support/routes.py, acting.py; olene-platform docs/support-mode.md).
// /support/<id> opens a session started at account.olenesoft.com/admin/support: the backend checks
// it and says which company; this switches to it (as a shared company) and goes home.
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthProvider";
import { useCompany } from "../hooks/useCompany";

const API_URL = process.env.REACT_APP_API_URL;

export default function SupportStart() {
  const { id } = useParams();
  const { t } = useTranslation();
  const auth = useAuth();
  const nav = useNavigate();
  const { refetch, switchCompany } = useCompany();
  const [error, setError] = useState("");

  useEffect(() => {
    let gone = false;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/support/${encodeURIComponent(id)}`, {
          headers: { Authorization: `Bearer ${auth.user?.access_token}` },
        });
        const body = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(body?.detail?.message || t("support_cant_open"));
        await refetch();
        if (gone) return;
        switchCompany(body.company_id);
        nav("/", { replace: true });
      } catch (e) {
        if (!gone) setError(e.message || t("support_cant_open"));
      }
    })();
    return () => { gone = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-lg shadow p-6 max-w-md w-full">
        {!error ? <p className="text-gray-700">{t("support_opening")}</p> : (
          <>
            <h1 className="text-lg font-semibold mb-2">{t("support_cant_open")}</h1>
            <p className="text-gray-600 text-sm mb-4">{error}</p>
            <button className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200 text-sm" onClick={() => nav("/", { replace: true })}>
              {t("support_back")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
